<div class="container">
  <h1 class="mb-4">
    The Aqaix API Platform
  </h1>
  <div>
    The Aqaix API Platform includes the following tools:

    <ul class="mt-2">
      <li>
        <strong>API Gateway</strong>
        The API Runtime server. Based on the robust, open source WSO2 API Gateway.
      </li>
      <li>
        <strong>API Publisher</strong>
        An administrative portal that a database owner can use to manage and publish APIs (into the API Store).
        The publisher allows API Administrators and Digital Managers to ensure API Governance factors such as consistency of entity naming.
      </li>
      <li>
        <strong>API Designer</strong>
        A developer tool that allows a database owner to quickly and easily implement APIs on a database,
        in many cases simply by using a standard SQL schema and generating the REST API.
      </li>
      <li>
        <strong>API Store</strong>
        A portal allowing database and API owners to control API access and monetization, and which consumer developers
        (those looking to develop applications and automate software processes using data)
        can browse and subscribe to APIs.
      </li>
    </ul>

    <div class="mt-4">
      These tools are a complete solution to all the challenges in implementing robust APIs and running an API program
      across an enterprise or ecosystem. Those challenges are:

      <table class="table table-bordered mt-2">
        <thead>
        <tr>
          <th>
            Challenges in API Management
          </th>
          <th>
            Aqaix API Tools
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            Easily creating APIs from data
          </td>
          <td>
            <div>
              The Aqaix API Tool Suite includes tools for pushbutton-simple creation of APIs based on database schema
            </div>
            <div class="mt-2">
              It even allows access to spreadsheet data
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Implementing robust, bank-grade security
          </td>
          <td>
            <div>
              Makes Oauth 2.0 security systems simple to implement
            </div>
            <div class="mt-2">
              API Security layers are additional to existing enterprise security layers
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Ensuring consistent, uniform APIs across diverse data sources and programmers
          </td>
          <td>
            Many facilities for ensuring good governance on APIs
          </td>
        </tr>
        <tr>
          <td>
            Easy discovery and adoption by programmers building apps and applications
          </td>
          <td>
            <div>
              Easy browsing of APIs
            </div>
            <div class="mt-2">
              Robust documentation to make usage easy
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Monetization of data
          </td>
          <td>
            Pricing systems, automatic controls and throttling, and billing-grade usage records
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
